import {
    Module,
    VuexModule,
    getModule,
    Mutation,
    Action,
} from 'vuex-module-decorators';
import store from '~common-store';
import { RoomsState, RoomData } from '~/interfaces/rooms.interface';
import { HomesModule } from '~/store/modules/homes';
import { DevicesModule } from '~/store/modules/devices';

@Module({ dynamic: true, store, name: 'rooms', namespaced: true })
class Rooms extends VuexModule implements RoomsState {
    rooms = [] as RoomData [];

    get currentRooms() {
        return this.rooms.filter((room) => room.homeId === HomesModule.currentHomeId);
    }

    get roomFromId() {
        return (id: string) => this.rooms.find((room) => room.id === id);
    }

    get roomModules() {
        // Display modules of the room in parameters that are related to the current gw.
        return (id: string) => {
            const room: RoomData | undefined = this.roomFromId(id);
            if (room && room.module_ids) {
                // get unique list of module ids in the room
                const uniqueModulesIds = [...new Set(room.module_ids)];
                const currentGatewayModuleIds: string[] = [];
                uniqueModulesIds.forEach((modId) => {
                    const mod = DevicesModule.getDeviceById(modId);
                    // filter modules to only have those linked to the current gateway
                    if (mod && mod.bridge === DevicesModule.currentGatewayId) {
                        currentGatewayModuleIds.push(modId);
                        // for NLAO & NLD we add the #1 and #2 modules ids to the room
                        if (['NLAO', 'NLD'].includes(mod.type)) {
                            currentGatewayModuleIds.push(`${modId}#1`, `${modId}#2`);
                        }
                    }
                });
                return currentGatewayModuleIds;
            }
        };
    }

    @Action
    reset() {
        this.context.commit('RESET_ROOMS');
    }

    @Mutation
    RESET_ROOMS() {
        this.rooms = [];
    }

    @Mutation
    SET_ROOMS(rooms: RoomData[]) {
        rooms.forEach((room) => {
            this.rooms.push(room);
        });

    }

}

export const RoomsModule = getModule(Rooms);
